import styles from './styles/SidebarSection.module.scss';

interface SidebarSectionNoDataProps {
    header: string;
}

const SidebarSectionNoData = ({ header }: SidebarSectionNoDataProps) => (
    <div className={styles.SidebarSection} data-testid={`sidebar-section-${header}-no-data`}>
        <p className={styles.SidebarSection__title}>{header}</p>
        <p className={styles.SidebarSection__nodata}>
            No&nbsp;
            <span className={styles.SidebarSection__nodataTitle}>{header}</span>
            &nbsp;assigned
        </p>
        <div className={styles.SidebarSection__footer}>
            <p className={styles.SidebarSection__footerText}>Total</p>0
        </div>
    </div>
);

export default SidebarSectionNoData;
